const ProfilePic = ({ image, initials }) => {
  return !image ? (
    <div
      style={{
        marginLeft: '25px',
        objectFit: 'cover',
        paddingTop: '4px',
      }}
      className="h-108 w-108 bg-lightgray circle rem-pad-width"
    >
      <span
        style={{
          fontSize: '40px',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '15px',
        }}
        className="white"
      >
        {initials}
      </span>
    </div>
  ) : (
    <img className="assoc_image" src={image} alt="Profile" />
  );
};

export default ProfilePic;
